module.exports = __webpack_public_path__ + "img/矩形 85@1x.e6c985d3.png";